import { render, staticRenderFns } from "./pointShop.vue?vue&type=template&id=54268c24&scoped=true&"
import script from "./pointShop.vue?vue&type=script&lang=js&"
export * from "./pointShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54268c24",
  null
  
)

export default component.exports